import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Grid from '@mui/material/Grid'

export default function EmailSent({onModalClose}: {onModalClose?: () => void}) {
  return (
    <>
      <DialogTitle title='Email Sent'></DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} lg={12}></Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button disabled={false} onClick={onModalClose} variant='text' color='primary' size='large'>
          Close
        </Button>
      </DialogActions>
    </>
  )
}
